<template>
  <div :class="activeFont">
    <div class="wrapper">
      <DefaultNavBar :homeURL="{ name: 'external-user.dashboard' }" :sidebarGroupTitle="sidebarGroupTitle" @toggle="sidebarMini" :logo="logo" style="width: 100%;right: 0px;left: 0px;">
        <template slot="responsiveRight">
          <ul class="navbar-nav ml-auto navbar-list">
            <li class="nav-item d-flex" v-nav-toggle>
              <div class="row align-self-center ">
                <lang-button />
              </div>
            </li>
          </ul>
        </template>
        <template slot="right">
          <ul class="navbar-nav ml-auto navbar-list">
            <li class="nav-item d-flex" style="margin: 0px 5px" v-nav-toggle>
              <div class="row align-self-center ">
                <div id="language" class="btn-group btn-group-sm" role="group" aria-label="Language">
                  <router-link :to="{ name: 'auth.login' }" class="btn btn-secondary bg-white text-success font-weight-bold">{{$t('globalTrans.login')}}</router-link>
                </div>
              </div>
            </li>
          </ul>
        </template>
      </DefaultNavBar>
      <div>
      <b-container>
        <div class="text-center" style="margin-top:7rem; margin-bottom: 1rem;">
          <h3 style="font-weight:bold; color:#2e2e2e">{{ $t('hospital_public_panel.hospital_module_name_hos') }}</h3>
          <div class="sub-title">
            <div class="line"></div>
            <h5 style="font-weight:medium; color:#2e2e2e">{{ $t('hospital_public_panel.choose_service') }}</h5>
            <div class="line"></div>
          </div>
        </div>
        <div class="button-wrapper">
          <b-row>
            <b-col sm="4">
              <router-link style="color:#551a8b" to="/portal/hospital-service/health-service">
                <b-card>
                  <div class="box">
                    <div class="icon">
                      <i class="fas fa-procedures"></i>
                    </div>
                    <p>{{ $t('hospital_public_panel.hospital_service') }}</p>
                  </div>
                </b-card>
              </router-link>
            </b-col>
            <b-col sm="4">
              <router-link style="color:#551a8b" to="/portal/hospital-service/donation-service">
                <b-card>
                  <div class="box">
                    <div class="icon">
                      <i class="fas fa-hand-holding-usd"></i>
                    </div>
                    <p>{{ $t('hospital_public_panel.donation') }}</p>
                  </div>
                </b-card>
              </router-link>
            </b-col>
            <b-col sm="4">
              <router-link style="color:#551a8b" to="/portal/hospital-service/hospital-shamiti">
                <b-card>
                  <div class="box">
                    <div class="icon">
                      <i class="fas fa-users"></i>
                    </div>
                    <p>{{ $t('hospital_public_panel.hospital_shamiti') }}</p>
                  </div>
                </b-card>
              </router-link>
            </b-col>
          </b-row>
        </div>
      </b-container>
        <div class="bouble">
            <img src="../assets/pubDashboardImage/corner-bg-up.png" class="img1 ">
            <img src="../assets/pubDashboardImage/corner-bg.png" class="img2 ">
        </div>
          <!-- <div class="main">
            <div class="image_container">
              <img src="../assets/pubDashboardImage/imgpsh_fullsize_anim.png" alt="" />

              <div class="button1">
                <div class="image_button1">
                <router-link style="color:#551a8b" to="/portal/hospital-service/health-service">
                  <img src="../assets/pubDashboardImage/icon_1.png" />
                </router-link>
              </div>
              <div class="Hospital_Service">
                <span>
                  <router-link style="color:#551a8b" to="/portal/hospital-service/health-service">
                    {{ $t('hospital_public_panel.hospital_service')}}
                  </router-link>
                </span>
              </div>
            </div>
            <div class="button3">
              <div class="image_button3">
                <router-link style="color:#551a8b" to="/portal/hospital-service/donation-service">
                  <img src="../assets/pubDashboardImage/icon_3.png" />
                </router-link>
              </div>
              <div class="Donation">
                <span>
                  <router-link style="color:#551a8b" to="/portal/hospital-service/donation-service">
                    {{ $t('hospital_public_panel.donation')}}
                  </router-link>
                </span>
              </div>
            </div>
            <div class="button4">
              <div class="image_button4">
                <router-link style="color:#551a8b" to="/portal/hospital-service/hospital-shamiti">
                  <img src="../assets/pubDashboardImage/icon_4.png" />
                </router-link>
              </div>
              <div class="Hospital_Shomiti__Membership">
                <span>
                  <router-link style="color:#551a8b" to="/portal/hospital-service/hospital-shamiti">
                    {{ $t('hospital_public_panel.hospital_shamiti')}}
                  </router-link>
                </span>
              </div>
            </div>
            </div>
          </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { core } from '../config/pluginInit'
import { mapActions, mapGetters } from 'vuex'
import DefaultNavBar from '../components/core/navbars/DefaultNavBar'
import SideBarItems from '../sidebar-menus/SideBarHealthLayout'
import profile from '../assets/images/user/user-1.jpeg'
import Logo from '../assets/images/logo.png'
import darkLoader from '../assets/images/darkMode/dark-logo.gif'
import WhiteLogo from '../assets/images/logo-2.png'
import LangButton from './Components/LangButton'

export default {
  name: 'VerticleLayout',
  components: {
    DefaultNavBar,
    LangButton
  },
  mounted () {
    this.layoutSetting(this.$route.name)

    if (window.performance) {
      this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
      this.$store.dispatch('ExternalUser/mutateHospitalExternalDropdown', { hasDropdownLoaded: false })
    }
  },
  created () {
    this.verticalMenu = SideBarItems.common
    if (this.authUser.user_type_id === 1 || this.authUser.user_type_id === 2) {
      this.verticalMenu = SideBarItems.dealer_panel
    }
    if (this.authUser === null) {
      this.logout()
    }
  },
  computed: {
    activeFont: function () {
      return this.$i18n.locale === 'en' ? 'font-en' : 'font-bn'
    },
    ...mapGetters({
      selectedLang: 'Setting/langState',
      // langsOptions: 'Setting/langOptionState',
      darkMode: 'Setting/darkModeState',
      colors: 'Setting/colorState',
      authUser: 'Auth/authUser'
    }),
    dataTest () {
      return this.$store.state.ExternalUserIrrigation
    },
    toggleSideIcon () {
      let show = true
      switch (this.$route.name) {
        case 'dashboard.home-3':
        case 'dashboard.home-4':
        case 'dashboard.home-5':
        case 'dashboard.home-6':
          show = false
          break
      }
      return show
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    currentLocale: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.localizeCommonDropdown({ value: newVal })
      }
    },
    $route: function (to, from) {
      this.layoutSetting(to.name)
    }
  },
  // sidebarTicket
  data () {
    return {
      animated: { enter: 'fadeInUp', exit: 'fadeOut' },
      verticalMenu: [],
      userProfile: profile,
      onlyLogo: false,
      onlyLogoText: false,
      sidebarGroupTitle: true,
      logo: Logo,
      SmallSidebarLogo: WhiteLogo,
      isLoad: false,
      notBookmarkRouts: []
    }
  },
  methods: {
    farmerBasicInfo () {
      return true
    },
    layoutSetting (routeName) {
      this.modeChange({ dark: this.darkMode })
      this.onlyLogo = true
      this.onlyLogoText = true
      this.sidebarGroupTitle = true
      switch (routeName) {
        case 'dashboard.home-5':
          this.onlyLogoText = true
          this.onlyLogo = false
          break
        case 'dashboard.home-6':
          this.logo = WhiteLogo
          this.onlyLogo = true
          this.onlyLogoText = false
          this.sidebarGroupTitle = false
          break
        default:
          if (this.darkMode) {
            this.logo = darkLoader
          } else {
            this.logo = Logo
          }
          break
      }
    },
    changeLogo (e) {
      this.logo = e
    },
    sidebarMini () {
      core.triggerSet()
      this.$store.dispatch('Setting/miniSidebarAction')
    },
    routerAnimationChange (e) {
      this.animated = e
    },
    ...mapActions({
      modeChange: 'Setting/layoutModeAction',
      localizeCommonDropdown: 'ExternalUser/localizeHospitalExternalDropdown'
    })
  }
}
</script>
<style scoped>
  @import url("../assets/css/custom.css");
  /* @import url("../assets/css/heath_public_dashboard/style.css"); */
  .bg-white iq-footer{
      margin-right: 0px !important;
  }
.sub-title{
  display: flex;
  justify-content: center;
  align-items: center;
}
.sub-title .line{
  width:100%;
  border-bottom: 2px double #ccc;
}
.sub-title h5{
  width: 50%;
  padding:5px;
  font-weight: bold;
}
  .button-wrapper .card{
    margin-top: 1rem;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  }
  .button-wrapper .card .card-body{
    padding: 0;
    box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
  }
  .box{
    text-align: center;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 10.1rem;
  }
  .button-wrapper .icon{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    padding: .3rem;
    color: #fff;
    width: 50px;
    height: 50px;
    border-radius: 4px;
    background-color: darkslateblue;
  }
  .button-wrapper p{
    margin-top: 8px;
    margin-bottom: 0;
    font-size: 20px;
    font-weight: bold;
    line-height: 25px;
    color: darkslateblue;
  }
.bouble{
  position: relative;
}
.img1{
  position: fixed;
  width: auto;
  height: auto;
  right: 0px;
  top: 72px;
}
.img2{
  position: fixed;
  width: 250px;
  height: 195.344px;
  left: 0px;
  bottom: 0px;
}
</style>
